"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OAuthComponentFactory = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _oauth = require("../oauth");

var _silentTokenRenew = require("./silent-token-renew");

var _retrieveIdToken = require("./retrieve-id-token");

var _loadingPage = require("./loading-page");

var _utils = require("../utils");

var _actions = require("./actions");

var _constants = require("./constants");

var _utils2 = require("../permission-sets/utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var VALID = _constants.oAuthStates.VALID,
    INVALID = _constants.oAuthStates.INVALID,
    LOGGING_IN = _constants.oAuthStates.LOGGING_IN,
    LOGGING_OUT = _constants.oAuthStates.LOGGING_OUT,
    LOADING = _constants.oAuthStates.LOADING;

var _Auth = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(_Auth, _Component);

  var _super = _createSuper(_Auth);

  function _Auth(props) {
    var _this;

    (0, _classCallCheck2.default)(this, _Auth);
    _this = _super.call(this, props);
    _this.oAuthHandler = _oauth.OAuth.oAuthHandler;
    return _this;
  }

  (0, _createClass2.default)(_Auth, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var handleLogin, authState, permissionSetIds, permissions, tenant, authenticationProvider, _this$oAuthHandler$ge;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                handleLogin = this.props.handleLogin;
                authState = LOGGING_IN;
                permissionSetIds = null;
                permissions = [];
                tenant = null;
                authenticationProvider = null;

                if (!this.oAuthHandler.isLoggedIn()) {
                  _context.next = 16;
                  break;
                }

                authState = this.oAuthHandler.hasValidToken() ? VALID : INVALID;

                if (!(authState === VALID)) {
                  _context.next = 16;
                  break;
                }

                _this$oAuthHandler$ge = this.oAuthHandler.getAccessToken().decodedAccessToken;
                permissionSetIds = _this$oAuthHandler$ge.permission_set;
                tenant = _this$oAuthHandler$ge.tenant;
                authenticationProvider = _this$oAuthHandler$ge.idp;
                _context.next = 15;
                return (0, _utils2.fetchPermissionSets)(permissionSetIds);

              case 15:
                permissions = _context.sent;

              case 16:
                handleLogin(authState, {
                  permissionSetIds: permissionSetIds,
                  permissions: permissions,
                  tenant: tenant,
                  authenticationProvider: authenticationProvider
                });

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "clearHashFromUrl",
    value: function clearHashFromUrl() {
      history.replaceState('', document.title, window.location.pathname + window.location.search);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          oAuthState = _this$props.oAuthState;

      switch (oAuthState) {
        case VALID:
          {
            this.clearHashFromUrl();
            return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_silentTokenRenew.SilentTokenRenew, null), /*#__PURE__*/_react.default.createElement(_retrieveIdToken.RetrieveIdToken, null), children);
          }

        case INVALID:
          // Renew token. Maybe display some warning or something in the future.
          return this.oAuthHandler.displayLoginPage();

        case LOGGING_IN:
          return this.oAuthHandler.displayLoginPage();

        case LOGGING_OUT:
          return this.oAuthHandler.signOut();

        case LOADING:
          return /*#__PURE__*/_react.default.createElement(_loadingPage.LoadingPage, null);

        default:
          return null;
      }
    }
  }]);
  return _Auth;
}(_react.Component);

(0, _defineProperty2.default)(_Auth, "propTypes", {
  children: _propTypes.default.node.isRequired,
  oAuthState: _propTypes.default.string.isRequired,
  handleLogin: _propTypes.default.func.isRequired
});

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    handleLogin: function handleLogin(newState, userData) {
      dispatch((0, _actions.logIn)(userData));
      dispatch((0, _actions.setOAuthState)(newState));
    }
  };
};

var mapStateToProps = function mapStateToProps(state) {
  var oAuthState = (0, _utils.getOAuthState)(state)[_constants.AUTH_STATE_KEY_NAME];

  return {
    oAuthState: oAuthState.state
  };
};

var OAuthComponentFactory = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Auth);
exports.OAuthComponentFactory = OAuthComponentFactory;
//# sourceMappingURL=oauth-component-factory.js.map